var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootballSchool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H68V68H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1920_2889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8845 58.9074C54.8943 59.5765 54.7221 60.1029 54.0727 60.3932H13.5625C12.9524 60.1127 12.7359 59.6257 12.7507 58.9664C12.795 56.6737 12.7212 54.3712 12.8589 52.0835C13.1394 47.3358 17.3508 43.0605 22.0886 42.5931C22.6347 42.539 23.1907 42.5635 23.7269 42.4652C24.3419 42.352 24.9963 42.2585 25.5178 41.9535C26.2656 41.5156 26.7969 41.6337 27.4464 42.1306C29.006 43.331 30.787 44.0149 32.7598 44.2068C35.5199 44.4675 37.9946 43.7296 40.1839 42.0666C40.8235 41.5845 41.3352 41.5353 42.0584 41.919C42.6635 42.2438 43.4015 42.4406 44.0854 42.4602C49.5464 42.6078 53.7185 46.1157 54.7123 51.4784C54.8304 52.113 54.8648 52.7723 54.8697 53.4217C54.8894 55.247 54.8697 57.0772 54.8845 58.9074Z",
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2344 22.3429L46.7424 20.9211C46.708 22.3528 46.5604 23.7599 46.1766 25.1374C45.7929 26.5199 45.2172 27.8188 44.3858 29.0192C44.371 28.2763 44.3661 27.5285 44.3317 26.7856C44.253 24.9111 44.0611 23.0465 43.3871 21.2704C43.2099 20.8079 42.9787 20.3553 42.7032 19.9421C41.7389 18.4759 40.2137 18.0381 38.6049 18.7465C37.6013 19.1893 36.5927 19.6124 35.5005 19.7895C32.4699 20.2815 29.7246 19.5435 27.2105 17.8708C26.876 17.6494 26.625 17.6199 26.2708 17.7921C24.8145 18.4858 23.9978 19.6813 23.5452 21.1622C23.1369 22.5053 23.0877 23.8878 23.1516 25.2801C23.2156 26.6232 23.437 27.9418 23.7666 29.2504C23.7764 29.2898 23.7715 29.3341 23.7272 29.4079C23.6633 29.3193 23.5944 29.2308 23.5354 29.1373C22.6596 27.7154 22.1972 26.146 21.8725 24.5323C21.5379 22.8841 21.4149 21.2163 21.3805 19.5435C21.3805 19.4058 21.3657 19.268 21.3509 19.0516C21.0951 19.3172 20.8983 19.5239 20.6376 19.7945C20.613 19.3959 20.5834 19.0663 20.5687 18.7367C20.5146 17.4575 20.672 16.2128 21.1886 15.032C22.0496 13.0592 23.5944 11.9128 25.6804 11.4504C26.0494 11.3667 26.2462 11.2585 26.3299 10.855C26.5562 9.78252 27.24 9.01994 28.1846 8.48859C29.2818 7.86869 30.4871 7.58333 31.7368 7.4751C32.1009 7.44558 32.4649 7.43082 32.8536 7.44066C32.5338 7.71617 32.091 7.91297 32.3419 8.48367C35.4218 7.07659 38.3737 7.75061 41.2863 9.06422C40.3466 8.99534 39.4315 9.08881 38.5311 9.39385C39.2445 9.63 39.9628 9.82188 40.6418 10.1023C43.1361 11.1404 44.804 13.0001 45.9011 15.401C46.8113 17.3886 47.1803 19.4993 47.2738 21.6591C47.2836 21.8805 47.2885 22.1019 47.2984 22.3233C47.2738 22.3331 47.2492 22.338 47.2295 22.3479L47.2344 22.3429Z",
    fill: "#D3AA29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_2889",
    x: 8.75,
    y: 5.43762,
    width: 50.1348,
    height: 60.9556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2889",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballSchool);
export default __webpack_public_path__ + "static/media/football_school.35877ee233c8cff7c99edf52a7aa849b.svg";
export { ForwardRef as ReactComponent };